import posthog from 'posthog-js';

// Initialize PostHog
export const initializePostHog = () => {
  // You'll need to replace this with your actual PostHog project API key
  // Get this from your PostHog dashboard at https://app.posthog.com/project/settings
  const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || 'phc_J2kPFtFvmyw1FGtALygAHu9EG8ai1OHoQbaVGknn72y';
  const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

  console.log('PostHog initialization:', {
    hasKey: !!POSTHOG_KEY,
    keyLength: POSTHOG_KEY?.length,
    host: POSTHOG_HOST,
    isValidKey: POSTHOG_KEY && POSTHOG_KEY !== 'your-posthog-key-here'
  });

  if (POSTHOG_KEY && POSTHOG_KEY !== 'your-posthog-key-here') {
    try {
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        // Enable session recording (optional)
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: {
            password: true,
          },
        },
        // Enable feature flags (optional)
        bootstrap: {},
        // Capture pageviews automatically
        capture_pageview: true,
        // Capture clicks automatically
        autocapture: true,
        // Add debug mode for development
        debug: process.env.NODE_ENV === 'development',
        // Ensure events are sent
        persistence: 'localStorage',
      });
      console.log('PostHog initialized successfully');
      
      // Send a test event to verify connection
      setTimeout(() => {
        trackEvent('posthog_initialized', {
          timestamp: new Date().toISOString(),
          user_agent: navigator.userAgent,
          url: window.location.href,
        });
      }, 1000);
    } catch (error) {
      console.error('Failed to initialize PostHog:', error);
    }
  } else {
    console.warn('PostHog not initialized - missing or invalid API key');
  }
};

// Track custom events
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  try {
    if (posthog.__loaded) {
      console.log('Tracking event:', eventName, properties);
      posthog.capture(eventName, properties);
    } else {
      console.warn('PostHog not loaded yet, queuing event:', eventName);
      posthog.capture(eventName, properties);
    }
  } catch (error) {
    console.error('Error tracking event:', eventName, error);
  }
};

// Identify users
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  try {
    console.log('Identifying user:', userId, properties);
    posthog.identify(userId, properties);
  } catch (error) {
    console.error('Error identifying user:', userId, error);
  }
};

// Track page views manually (if needed)
export const trackPageView = (pageName: string, properties?: Record<string, any>) => {
  posthog.capture('$pageview', {
    $current_url: window.location.href,
    page_name: pageName,
    ...properties,
  });
};

// Set user properties
export const setUserProperties = (properties: Record<string, any>) => {
  posthog.people.set(properties);
};

// Reset user (on logout)
export const resetUser = () => {
  posthog.reset();
};

export default posthog;
